import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';
import { onClickOutside, useScroll } from '@vueuse/core';
import { useCookies } from '@vueuse/integrations/useCookies';
import { useOpenClose } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BookMeetingPopup',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { isOpen, open, close } = useOpenClose();
const popup = ref();
const cookies = useCookies(['book-meeting']);
const bmCookies = cookies.get('book-meeting') ?? {};

const setCookies = (key: string, value: any) => {
  cookies.set('book-meeting', { ...bmCookies, [key]: value });
};

const bookMeeting = () => {
  if (!bmCookies.isBooked) setCookies('isBooked', true);

  const { button } = props.data.popup;

  if (button?.link) window.open(button.link, button.target || '_blank');

  close();
};

const showPopupOnScroll = () => {
  const triggerEl = document?.getElementById('section-awards');
  if (!triggerEl) return;

  const { y } = useScroll(window);

  const unwatch = watch(y, (value) => {
    if (value < triggerEl?.offsetTop) return;

    setCookies('init', true);
    unwatch();
    open();
  });
};

onClickOutside(popup as any, () => close());

onMounted(() => {
  if (!bmCookies.init && !bmCookies.isBooked) showPopupOnScroll();
});

return { __sfc: true,props, isOpen, open, close, popup, cookies, bmCookies, setCookies, bookMeeting, showPopupOnScroll }
}

})